import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import logo from "../media/TCOpfingen_Logo.png";
import { FaBars } from 'react-icons/fa';
import Sidebar from './Sidebar';
import { Box, AppBar, Toolbar, IconButton, Button, Typography } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../provider/auth';

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();

  const navItems = [
    { text: 'Buchen', path: '/' },
    // { text: 'Turniere', path: '/tournaments' },
    { text: 'Konto', path: '/account' },
    { text: 'Kontakt', path: '/contact' },
    // { text: 'Ergebnisse', path: '/results' },
  ];

  const adminItems = [
    { text: 'Dashboard', path: '/admin/dashboard' },
    { text: 'Mitglieder', path: '/admin/members' },
    { text: 'Buchungen', path: '/admin/bookings' },
    { text: 'Gastspieler', path: '/admin/guests' },
    { text: 'Termine', path: '/admin/events' },
    // { text: 'Turniere', path: '/admin/tournaments' },
    { text: 'Verein', path: '/admin/club' },
  ];
  return (
    <>
      {/* Top Navbar for Desktop */}
      <AppBar 
        position="sticky" 
        sx={{ 
          display: { xs: 'none', md: 'flex' },
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          color: 'black',
          boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
          zIndex: 1000,
          top: 0
        }}
      >
        <Box sx={{ px: 2, py: 0.5, maxWidth: '1600px', mx: 'auto', width: '100%' }}>
          {/* Row 1: General Nav & Logout */}
          <Toolbar variant="dense" sx={{ justifyContent: 'space-between', px: '0 !important' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <NavLink to="/">
                <img src={logo} alt="Logo" style={{ height: 25, marginRight: '10px', cursor: 'pointer' }} />
              </NavLink>
              {navItems.map((item) => (
                <Button
                  key={item.text}
                  component={NavLink}
                  to={item.path}
                  sx={{ 
                    color: 'inherit',
                    mx: 0.2, // Reduced from 0.5
                    px: 1,   // Explicit smaller padding
                    fontSize: '0.8rem',
                    minWidth: 'auto',
                    '&.active': { fontWeight: 'bold', borderBottom: '2px solid' }
                  }}
                >
                  {item.text}
                </Button>
              ))}
            </Box>

            <Button
              onClick={logout}
              startIcon={<LogoutIcon />}
              sx={{ color: 'text.secondary', fontSize: '0.8rem', minWidth: 'auto' }}
            >
              Abmelden
            </Button>
          </Toolbar>

          {/* Row 2: Admin Nav (Only if Admin) */}
          {user?.role === 2 && (
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              borderTop: '1px solid rgba(0,0,0,0.05)',
              mt: 0.5,
              pt: 0.5,
              flexWrap: 'wrap'
            }}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'primary.main', mr: 1 }}>
                Admin:
              </Typography>
              {adminItems.map((item) => (
                <Button
                  key={item.text}
                  component={NavLink}
                  to={item.path}
                  sx={{ 
                    color: 'primary.main',
                    mx: 0.1, // Reduced from 0.3
                    px: 0.8, // Explicit smaller padding
                    fontSize: '0.75rem',
                    py: 0.3,
                    minWidth: 'auto',
                    fontWeight: 'medium',
                    '&.active': { fontWeight: 'bold', textDecoration: 'underline' }
                  }}
                >
                  {item.text}
                </Button>
              ))}
            </Box>
          )}
        </Box>
      </AppBar>

      {/* Floating Burger for Mobile */}
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={() => setMobileOpen(true)}
        sx={{ 
          display: { md: 'none' },
          position: 'fixed',
          top: 10,
          left: 10,
          zIndex: 1100,
          bgcolor: 'rgba(255,255,255,0.8)',
          boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
          '&:hover': { bgcolor: 'white' }
        }}
      >
        <FaBars size={20} />
      </IconButton>
      
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
    </>
  );
}

export default Navbar;
